export default "__VITE_ASSET__Bv4VD2zg__"